import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { fg } from '@atlaskit/platform-feature-flags/fg';

export const isEntityAnnotationExperimentEnabled = (
	type: 'person' | 'inferred-project',
): boolean => {
	const cohort = expVal<string>(
		'convo_ai_entity_hover_cards_non_hello_exp',
		'hover_card_cohort',
		'control',
	);
	return cohort === type || cohort === 'all';
};

export const isPeopleEntityAnnotationEnabled = (): boolean =>
	fg('rovo_chat_people_entity_hover_cards') || isEntityAnnotationExperimentEnabled('person');

export const isInferredProjectEntityAnnotationEnabled = (): boolean =>
	fg('rovo_chat_inferred_project_hover_cards') ||
	isEntityAnnotationExperimentEnabled('inferred-project');
